
import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import FareRule from "./FareRule";
import { AuthContext } from "../../Routes/AuthProvider"
import * as XLSX from "xlsx";

const DomRoundTrip = ({
  onwardFlights = [],
  returnFlights = [],
  filteredOnwardFlights = [],
  filteredReturnFlights = [],
  filters,
  onFilterChange,
  loading,
  data,
  error,
  handleBookNow,
  requestBody,
}) => {
  const [selectedOnwardFlight, setSelectedOnwardFlight] = useState(null);
  const [selectedReturnFlight, setSelectedReturnFlight] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);

  const { name, userName, roles, corporateId } = useContext(AuthContext);

  // const onwardList =
  //   filteredOnwardFlights?.length > 0 ? filteredOnwardFlights : onwardFlights;

  // const returnList =
  //   filteredReturnFlights?.length > 0 ? filteredReturnFlights : returnFlights;
  // SORTING (CHEAPEST ON TOP BY DEFAULT)
  const [onwardSortType, setOnwardSortType] = useState("DEPARTURE");
  const [returnSortType, setReturnSortType] = useState("DEPARTURE");
  const [selectedFare, setSelectedFare] = useState(null);
  const [loadFareRule, setLoadFareRule] = useState(false);
  const [activeTab, setActiveTab] = useState("info");
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [selectedFareMap, setSelectedFareMap] = useState({});
  const [fareRuleIndex, setFareRuleIndex] = useState(null);

  const [showAdSelctRound, setshowAdSelctRound] = useState(false);
  const [showAdSelctOnwrd, setshowAdSelctOnwrd] = useState(false);
  const [selectedShareFlights, setSelectedShareFlights] = useState([]);
  const [removedShareFares, setRemovedShareFares] = useState([]);


  // console.log("selectedonwardFlights",onwardFlights );
  //       console.log("selectedreturnFlights",returnFlights );
  const sortFlights = (list = [], sortType) => {
    const copied = [...list];
    const getMinFare = (flight) => {
      if (flight.fares && flight.fares.length > 0) {
        return Math.min(...flight.fares.map(f => f.totalFare || 0));
      }
      return flight.fareDetails?.totalFare || 0;
    };

    const getDurationInMinutes = (duration) => {
      if (!duration) return 99999;
      const [h, m] = duration.split(":").map(Number);
      return h * 60 + m;
    };

    switch (sortType) {
      case "CHEAPEST":
        return copied.sort(
          (a, b) => getMinFare(a) - getMinFare(b)
        );

      case "FASTEST":
        return copied.sort(
          (a, b) =>
            getDurationInMinutes(a.totalDuration) -
            getDurationInMinutes(b.totalDuration)
        );

      case "NONSTOP":
        return copied.sort(
          (a, b) =>
            (a.segments?.length === 1 ? 0 : 1) -
            (b.segments?.length === 1 ? 0 : 1)
        );

      case "DEPARTURE":
        return copied.sort(
          (a, b) =>
            new Date(a.segments?.[0]?.departDateTime) -
            new Date(b.segments?.[0]?.departDateTime)
        );

      default:
        return copied;
    }
  };


  const sortedOnwardFlights = useMemo(() => {
    const list = filteredOnwardFlights ?? onwardFlights;
    return sortFlights(list, onwardSortType);
  }, [filteredOnwardFlights, onwardSortType]);

  const sortedReturnFlights = useMemo(() => {
    const list = filteredReturnFlights ?? returnFlights;
    return sortFlights(list, returnSortType);
  }, [filteredReturnFlights, returnSortType]);
  // Sorting End

  // copy start

  const [selectedOnwardFlights, setSelectedOnwardFlights] = useState([]);
  const [selectedReturnFlights, setSelectedReturnFlights] = useState([]);

  // Use a stable identifier so sorting does not change the selection.

  const getFlightKey = (flight) => {
    if (!flight) return "";

    const segments = flight.segments || [];

    // Build a unique key from the flight's actual segments.
    if (segments.length > 0) {
      return segments
        .map((segment) =>
          [
            segment.departDateTime,
            segment.arrivalDateTime,
            segment.airLineCode,
            segment.flightNumber,
            segment.departAirportCode,
            segment.arrivalAirportCode,
          ]
            .map((value) => String(value ?? ""))
            .join("~")
        )
        .join("||");
    }

    return flight.itemNo != null ? `item-${flight.itemNo}` : "";
  };

  // Select or deselect ONLY the clicked flight.
  const handleShareFlightChange = (flight, type, isChecked) => {
    const flightKey = getFlightKey(flight);

    if (!flightKey) return;

    const setSelection =
      type === "onward"
        ? setSelectedOnwardFlights
        : setSelectedReturnFlights;

    setSelection((previous) => {
      if (isChecked) {
        return previous.includes(flightKey)
          ? previous
          : [...previous, flightKey];
      }

      return previous.filter((key) => key !== flightKey);
    });
  };



  // Get the selected flight objects for the share modal.
  const selectedOnwardFlightsToShare = sortedOnwardFlights.filter((flight) =>
    selectedOnwardFlights.includes(getFlightKey(flight))
  );

  const selectedReturnFlightsToShare = sortedReturnFlights.filter((flight) =>
    selectedReturnFlights.includes(getFlightKey(flight))
  );


  const getSelectedShareDataDomR = () => {
    const selectedOptions = [
      ...selectedOnwardFlightsToShare.map((flight) => ({
        flight,
        journeyLabel: "Onward",
      })),
      ...selectedReturnFlightsToShare.map((flight) => ({
        flight,
        journeyLabel: "Return",
      })),
    ];

    return selectedOptions.map(({ flight, journeyLabel }, index) => {
      const segments = Array.isArray(flight?.segments)
        ? flight.segments
        : [];

      const journeySegments = segments.map((segment) => ({
        ...segment,
        journeyLabel,
      }));

      const onwardSegments =
        journeyLabel === "Onward" ? journeySegments : [];

      const returnSegments =
        journeyLabel === "Return" ? journeySegments : [];

      const getRoute = (segmentList) => {
        if (!segmentList.length) return [];

        return [
          segmentList[0].departAirportCode,
          ...segmentList.map((segment) => segment.arrivalAirportCode),
        ].filter(Boolean);
      };

      const fares = (Array.isArray(flight?.fares) ? flight.fares : [])
        .map((fare, fareIndex) => ({
          ...fare,
          fareIndex,
          fareKey: `${journeyLabel}-${getFlightKey(flight)}-${fareIndex}`,
        }))
        .filter((fare) => !removedShareFares.includes(fare.fareKey));

      return {
        optionIndex: index + 1,
        flight,
        journey: journeyLabel,
        allSegments: journeySegments,
        onwardSegments,
        returnSegments,
        onwardRoute: getRoute(onwardSegments),
        returnRoute: getRoute(returnSegments),
        fares,
      };
    });
  };

  const handleWhatsAppSelectedFlightsDomR = () => {
    const selectedFlights = getSelectedShareDataDomR();

    if (!selectedFlights.length) {
      window.alert("Please select at least one flight option.");
      return;
    }

    const message = selectedFlights
      .map((option) => {
        const {
          optionIndex,
          journey,
          allSegments = [],
          onwardRoute = [],
          returnRoute = [],
          fares = [],
        } = option;

        const route =
          journey === "Onward" ? onwardRoute : returnRoute;

        const flightDetails = allSegments
          .map((segment) => {
            const airline =
              segment.airLineName || segment.airLineCode || "";

            const flightNumber = segment.flightNumber || "";

            return (
              `${airline} ${flightNumber}\n` +
              `Departure: ${getShareDateTime(segment.departDateTime)} ` +
              `(${segment.departAirportCode || "—"})\n` +
              `Arrival: ${getShareDateTime(segment.arrivalDateTime)} ` +
              `(${segment.arrivalAirportCode || "—"})\n` +
              `Duration: ${segment.duration || "—"}`
            );
          })
          .join("\n\n");

        const fareDetails = fares.length
          ? fares
            .map((fare) => {
              const fareName = getShareFareName(
                fare,
                fare.fareIndex
              );

              const amount = getShareAmountText(fare);
              const refundStatus = getShareRefundStatus(fare);

              return (
                `${fareName}: INR ${amount} ` +
                `(${refundStatus})`
              );
            })
            .join("\n")
          : "No fares available";

        return (
          `Option ${optionIndex} - ${journey}\n` +
          `Route: ${route.join(" → ") || "—"}\n\n` +
          `${flightDetails}\n\n` +
          `Fares:\n${fareDetails}`
        );
      })
      .join("\n\n--------------------\n\n");

    const whatsappUrl =
      `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };


  const handleDownloadSelectedFlightsDomR = () => {
    const selectedFlights = getSelectedShareDataDomR();

    if (!selectedFlights.length) {
      window.alert("Please select at least one flight option.");
      return;
    }

    const flightRows = [];
    const fareRows = [];

    selectedFlights.forEach((option) => {
      const {
        optionIndex,
        allSegments,
        onwardRoute,
        returnRoute,
        fares,
      } = option;

      allSegments.forEach((segment) => {
        const journeySegments =
          segment.journeyLabel === "Onward"
            ? option.onwardSegments
            : option.returnSegments;

        const route =
          segment.journeyLabel === "Onward"
            ? onwardRoute
            : returnRoute;

        flightRows.push({
          "Option": `Option ${optionIndex}`,
          "Journey": segment.journeyLabel,
          "Airline": segment.airLineName || "",
          "Airline Code": segment.airLineCode || "",
          "Flight Number": segment.flightNumber || "",
          "Departure Date & Time": getShareDateTime(
            segment.departDateTime
          ),
          "Departure Airport": getShareAirport(
            segment.departAirportCode
          ),
          "Arrival Date & Time": getShareDateTime(
            segment.arrivalDateTime
          ),
          "Arrival Airport": getShareAirport(
            segment.arrivalAirportCode
          ),
          "Duration": segment.duration || "",
          "Stops": journeySegments.length <= 1
            ? "Non-stop"
            : `${journeySegments.length - 1} stop(s)`,
          "Complete Route": route.join(" → "),
        });
      });

      fares.forEach((fare) => {
        fareRows.push({
          "Option": `Option ${optionIndex}`,
          "Onward Route": onwardRoute.join(" → "),
          "Return Route": returnRoute.join(" → "),
          "Fare Type": getShareFareName(fare, fare.fareIndex),
          "Amount (INR)": getShareAmount(fare),
          "Price Type": getShareRefundStatus(fare),
        });
      });
    });

    const workbook = XLSX.utils.book_new();

    const flightSheet = XLSX.utils.json_to_sheet(
      flightRows.length
        ? flightRows
        : [{ Message: "No flight segment details available" }]
    );

    flightSheet["!cols"] = [
      { wch: 14 },
      { wch: 12 },
      { wch: 24 },
      { wch: 14 },
      { wch: 16 },
      { wch: 24 },
      { wch: 18 },
      { wch: 24 },
      { wch: 18 },
      { wch: 14 },
      { wch: 14 },
      { wch: 42 },
    ];

    const fareSheet = XLSX.utils.json_to_sheet(
      fareRows.length
        ? fareRows
        : [{ Message: "No fares available" }]
    );

    fareSheet["!cols"] = [
      { wch: 14 },
      { wch: 32 },
      { wch: 32 },
      { wch: 24 },
      { wch: 18 },
      { wch: 20 },
    ];

    XLSX.utils.book_append_sheet(
      workbook,
      flightSheet,
      "Flight Details"
    );

    XLSX.utils.book_append_sheet(
      workbook,
      fareSheet,
      "Fares"
    );

    XLSX.writeFile(
      workbook,
      "Selected_International_Flights.xlsx"
    );
  };


  const handleCopySelectedFlightsDomR = async () => {
    const selectedFlights = getSelectedShareDataDomR();

    if (!selectedFlights || selectedFlights.length === 0) {
      window.alert("Please select at least one flight option.");
      return;
    }

    const tableStyle =
      "border-collapse:collapse;width:100%;font-family:Arial,Helvetica,sans-serif;font-size:12px;margin:10px 0 18px 0;";

    const thStyle =
      "border:1px solid #d5d5d5;background-color:#110942;color:#ffffff;padding:9px;text-align:center;font-weight:bold;";

    const tdStyle =
      "border:1px solid #d5d5d5;padding:8px;text-align:center;vertical-align:middle;";

    // Return an absolute URL so the image can load outside the React app.
    const getAirlineLogoUrl = (airLineCode) => {
      if (!airLineCode) return "";

      const code = String(airLineCode).trim();

      // Prevent invalid paths in the generated HTML.
      if (!/^[a-zA-Z0-9_-]+$/.test(code)) return "";

      return `${window.location.origin}/assets/images/Flight_Images/${encodeURIComponent(
        code
      )}.gif`;
    };

    let html = `
      <div style="font-family:Arial,Helvetica,sans-serif;color:#333333;background:#ffffff;">
        <p style="margin:0 0 12px 0;">Dear Sir/Ma'am,</p>
        <p style="margin:0 0 16px 0;">
          Please find the selected international round-trip flight options below.
        </p>
    `;

    let plainText =
      "Dear Sir/Ma'am,\n\n" +
      "Please find the selected international round-trip flight options below.\n\n";

    selectedFlights.forEach((option) => {
      const {
        optionIndex,
        allSegments = [],
        onwardRoute = [],
        returnRoute = [],
        onwardSegments = [],
        returnSegments = [],
        fares = [],
      } = option;

      html += `
        <h3 style="font-family:Arial,Helvetica,sans-serif;color:#110942;font-size:16px;margin:18px 0 8px 0;">
          Option ${escapeShareHtml(optionIndex)}
        </h3>
  
        <table style="${tableStyle}">
          <thead>
            <tr>
              <th style="${thStyle}">Journey</th>
              <th style="${thStyle}">Route</th>
              <th style="${thStyle}">Travel Date</th>
            </tr>
          </thead>
          <tbody>
      `;

      const journeyRows = [
        {
          name: "Onward",
          route: onwardRoute,
          segments: onwardSegments,
        },
        {
          name: "Return",
          route: returnRoute,
          segments: returnSegments,
        },
      ].filter((journey) => journey.segments.length > 0);

      journeyRows.forEach((journey) => {
        const routeText = journey.route.join(" → ");
        const travelDate = getShareDateTime(
          journey.segments[0]?.departDateTime
        );

        html += `
          <tr>
            <td style="${tdStyle}">${escapeShareHtml(journey.name)}</td>
            <td style="${tdStyle}">${escapeShareHtml(routeText)}</td>
            <td style="${tdStyle}">${escapeShareHtml(travelDate)}</td>
          </tr>
        `;

        plainText +=
          `${journey.name}: ${routeText} | ` +
          `Travel date: ${travelDate}\n`;
      });

      html += `
          </tbody>
        </table>
  
        <table style="${tableStyle}">
          <thead>
            <tr>
              <th style="${thStyle}">Journey</th>
              <th style="${thStyle}">Flight</th>
              <th style="${thStyle}">Departure</th>
              <th style="${thStyle}">Arrived</th>
              <th style="${thStyle}">Duration</th>
              <th style="${thStyle}">Stops</th>
              <th style="${thStyle}">Route</th>
            </tr>
          </thead>
          <tbody>
      `;

      allSegments.forEach((segment) => {
        const journeySegments =
          segment.journeyLabel === "Onward"
            ? onwardSegments
            : returnSegments;

        const route =
          segment.journeyLabel === "Onward"
            ? onwardRoute
            : returnRoute;

        const airlineName = segment.airLineName || "";
        const airlineCode = segment.airLineCode || "";
        const flightNumber = segment.flightNumber || "";

        const logoUrl = getAirlineLogoUrl(airlineCode);

        const flightName =
          `${airlineName} ${airlineCode}` +
          (flightNumber ? `-${flightNumber}` : "");

        // Include the airline logo directly in the copied HTML.
        // The absolute URL allows the receiving email client to load it.
        const flightCellHTML = `
          <table
            cellpadding="0"
            cellspacing="0"
            border="0"
            style="border-collapse:collapse;margin:0 auto;"
          >
            <tr>
              ${logoUrl
            ? `
                    <td style="padding:4px 7px 4px 0;vertical-align:middle;">
                      <img
                        src="${escapeShareHtml(logoUrl)}"
                        alt="${escapeShareHtml(airlineName || airlineCode)}"
                        width="35"
                        style="display:block;width:35px;height:auto;border:0;outline:none;text-decoration:none;"
                      />
                    </td>
                  `
            : ""
          }
              <td style="padding:4px;vertical-align:middle;text-align:left;">
                ${escapeShareHtml(flightName.trim())}
              </td>
            </tr>
          </table>
        `;

        const departureText =
          `${getShareDateTime(segment.departDateTime)} | ` +
          `${segment.departAirportCode || "—"}`;

        const arrivalText =
          `${getShareDateTime(segment.arrivalDateTime)} | ` +
          `${segment.arrivalAirportCode || "—"}`;

        const stopsText =
          journeySegments.length <= 1
            ? "Non-stop"
            : `${journeySegments.length - 1} stop(s)`;

        html += `
          <tr>
            <td style="${tdStyle}">
              ${escapeShareHtml(segment.journeyLabel)}
            </td>
  
            <td style="${tdStyle};text-align:left;">
              ${flightCellHTML}
            </td>
  
            <td style="${tdStyle}">
              ${escapeShareHtml(departureText)}
            </td>
  
            <td style="${tdStyle}">
              ${escapeShareHtml(arrivalText)}
            </td>
  
            <td style="${tdStyle}">
              ${escapeShareHtml(segment.duration || "—")}
            </td>
  
            <td style="${tdStyle}">
              ${escapeShareHtml(stopsText)}
            </td>
  
            <td style="${tdStyle}">
              ${escapeShareHtml(route.join(" → "))}
            </td>
          </tr>
        `;

        plainText +=
          `${segment.journeyLabel}: ${flightName} | ` +
          `Departure: ${departureText} | ` +
          `Arrival: ${arrivalText} | ` +
          `Duration: ${segment.duration || "—"} | ` +
          `Stops: ${stopsText} | ` +
          `Route: ${route.join(" → ")}\n`;
      });

      html += `
          </tbody>
        </table>
  
        <table style="${tableStyle}">
          <thead>
            <tr>
              <th style="${thStyle}">Fare Type</th>
              <th style="${thStyle}">Amount (INR)</th>
              <th style="${thStyle}">Price Type</th>
            </tr>
          </thead>
          <tbody>
      `;

      if (fares.length === 0) {
        html += `
          <tr>
            <td colspan="3" style="${tdStyle}">
              No fares available
            </td>
          </tr>
        `;

        plainText += "No fares available.\n";
      } else {
        fares.forEach((fare) => {
          const fareName = getShareFareName(fare, fare.fareIndex);
          const amount = getShareAmountText(fare);
          const refundStatus = getShareRefundStatus(fare);

          const refundColor =
            refundStatus === "Refundable" ? "green" : "red";

          html += `
            <tr>
              <td style="${tdStyle}">
                ${escapeShareHtml(fareName)}
              </td>
  
              <td style="${tdStyle}">
                ₹ ${escapeShareHtml(amount)}
              </td>
  
              <td style="${tdStyle};color:${refundColor};font-weight:500;">
                ${escapeShareHtml(refundStatus)}
              </td>
            </tr>
          `;

          plainText +=
            `Fare: ${fareName} | Amount: INR ${amount} | ` +
            `${refundStatus}\n`;
        });
      }

      html += `
          </tbody>
        </table>
      `;

      plainText += "\n";
    });

    html += "</div>";

    try {
      // Preferred method: copy formatted HTML and plain text together.
      if (
        navigator.clipboard?.write &&
        typeof ClipboardItem !== "undefined"
      ) {
        const htmlBlob = new Blob([html], {
          type: "text/html",
        });

        const textBlob = new Blob([plainText], {
          type: "text/plain",
        });

        await navigator.clipboard.write([
          new ClipboardItem({
            "text/html": htmlBlob,
            "text/plain": textBlob,
          }),
        ]);
      } else {
        // Fallback for browsers without rich clipboard support.
        const temporaryElement = document.createElement("div");

        temporaryElement.contentEditable = "true";
        temporaryElement.style.position = "fixed";
        temporaryElement.style.left = "-99999px";
        temporaryElement.style.top = "0";
        temporaryElement.style.width = "1000px";
        temporaryElement.innerHTML = html;

        document.body.appendChild(temporaryElement);

        const selection = window.getSelection();
        const range = document.createRange();

        range.selectNodeContents(temporaryElement);
        selection?.removeAllRanges();
        selection?.addRange(range);

        temporaryElement.focus();

        const copied = document.execCommand("copy");

        selection?.removeAllRanges();
        document.body.removeChild(temporaryElement);

        if (!copied) {
          throw new Error("Copy command was not successful.");
        }
      }

      window.alert(
        "Selected flight details copied. Open your email and paste them into the message."
      );
    } catch (error) {
      console.error("Copy selected flights failed:", error);

      window.alert(
        "Could not copy formatted flight details. Please allow clipboard access and try again."
      );
    }
  };


  // ======================================
  // SHARE FLIGHT HELPER FUNCTIONS
  // ======================================

  // Format flight departure and arrival date/time.
  const getShareDateTime = (dateTime) => {
    if (!dateTime) return "—";

    const date = new Date(dateTime);

    if (Number.isNaN(date.getTime())) {
      return String(dateTime);
    }

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Return an airport code or a fallback value.
  const getShareAirport = (airport) => {
    if (!airport) return "—";

    if (typeof airport === "string") {
      return airport;
    }

    return (
      airport.airportCode ||
      airport.code ||
      airport.cityCode ||
      airport.name ||
      "—"
    );
  };

  // Escape HTML values before inserting them into copied HTML.
  const escapeShareHtml = (value) => {
    return String(value ?? "—").replace(/[&<>"']/g, (character) => {
      const htmlEntities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      };

      return htmlEntities[character];
    });
  };

  // Get the fare name displayed in the share popup.
  const getShareFareName = (fare, fareIndex = 0) => {
    const fareInfo = fare?.journeyFareInfos?.[0] || {};

    return (
      fare?.fareName ||
      fare?.fareType ||
      fare?.type ||
      fareInfo?.fareName ||
      fareInfo?.fareType ||
      fareInfo?.type ||
      `Fare ${Number(fareIndex) + 1}`
    );
  };

  // Get the fare amount as a numeric value.
  const getShareAmount = (fare) => {
    const fareInfo = fare?.journeyFareInfos?.[0] || {};

    const amount =
      fare?.totalFare ??
      fare?.fareDetails?.totalFare ??
      fareInfo?.totalFare ??
      fare?.amount ??
      fare?.price ??
      0;

    const parsedAmount = Number(amount);

    return Number.isFinite(parsedAmount) ? parsedAmount : 0;
  };

  // Format the fare amount for WhatsApp or copied text.
  const getShareAmountText = (fare) => {
    return getShareAmount(fare).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Get the refundable/non-refundable status.
  const getShareRefundStatus = (fare) => {
    const fareInfo = fare?.journeyFareInfos?.[0] || {};

    const refundable =
      fare?.isRefundable ??
      fareInfo?.isRefundable ??
      fare?.refundable ??
      fareInfo?.refundable;

    if (refundable === true || refundable === 1 || refundable === "true") {
      return "Refundable";
    }

    if (
      refundable === false ||
      refundable === 0 ||
      refundable === "false"
    ) {
      return "Non Refundable";
    }

    return "N/A";
  };

  // copy End




  const handleViewMoreFare = (flight) => {
    if (!flight) return;

    //console.log("View More Fare", flight);
    setSelectedFlight(flight);
    setSelectedFare(null);

    setTimeout(() => {
      const offcanvas = document.getElementById("ViewMoreFare");
      if (offcanvas) {
        const bsOffcanvas = new window.bootstrap.Offcanvas(offcanvas);
        bsOffcanvas.show();
      }
    }, 50); // wait for React to update state
  };

  const formatTime = (dt) =>
    dt
      ? new Date(dt).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
      : "";

  const renderFlights = (list, type) => {
    if (!list || list.length === 0) return <p>No {type} flights found</p>;

    return list.map((f, idx) => {
      const segments = f?.segments || [];
      const firstSeg = segments[0] || {};
      const lastSeg = segments[segments.length - 1] || {};

      const airLineCode = firstSeg.airLineCode || "";
      const airLineName = firstSeg.airLineName || "Unknown Airline";

      const checked =
        type === "onward"
          ? selectedOnwardFlight === f
          : selectedReturnFlight === f;

      const stops = segments.length > 0 ? segments.length - 1 : 0;

      return (
        <div
          key={idx}
          className={`prodct_lst_round_main rept ${checked ? "selected-flight" : ""
            }`}
        >

          <div className="prodct_lst_round">
            {/* Airline */}
            <div className="item_bx">
              <div className="flight_img_round">
                <img
                  src={`/assets/images/Flight_Images/${airLineCode}.gif`}
                  alt={airLineName}
                  width="50"
                />
              </div>
              <div className="flight_se">
                <span>{airLineName}</span>
                {f?.segments?.map((seg, i) => (
                  <span className="multi_flgt" key={i}>
                    {seg.airLineCode}-{seg.flightNumber}
                    {i < f.segments.length - 1 && " || "}
                  </span>
                ))}
              </div>
            </div>

            {/* Depart */}
            <div className="item_bx">
              <div className="timer">
                <h4>{formatTime(firstSeg.departDateTime)}</h4>
                <p>{firstSeg.departCityName}</p>
              </div>
            </div>

            {/* Duration */}
            <div className="item_bx">
              <div className="deruation">
                <p>
                  {type === "onward" ? (
                    <>
                      {(() => {
                        const [hours, minutes] = (f.totalDuration || "00:00").split(":");
                        const h = parseInt(hours, 10);
                        const m = parseInt(minutes, 10);

                        const totalDuration =
                          `${h > 0 ? h + "h " : ""}${m > 0 ? m + "m" : ""}`.trim();

                        return <>{totalDuration}</>;
                      })()}
                    </>
                  ) : (
                    <>
                      {(() => {
                        const [hours, minutes] = (f.totalDuration || "00:00").split(":");
                        const h = parseInt(hours, 10);
                        const m = parseInt(minutes, 10);

                        const totalDuration =
                          `${h > 0 ? h + "h " : ""}${m > 0 ? m + "m" : ""}`.trim();

                        return <>{totalDuration}</>;
                      })()}
                    </>
                  )}


                  {/* {f.totalDuration} */}
                </p>
                <div className="bordr_top">
                  <i className="fa fa-plane"></i>
                </div>
                <p className="stops">
                  {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                </p>
              </div>
            </div>

            {/* Arrival */}
            <div className="item_bx text-center">
              <div className="timer">
                <h4>{formatTime(lastSeg.arrivalDateTime)}</h4>
                <p>{lastSeg.arrivalCityName || lastSeg.destination}</p>
              </div>
            </div>

            {/* Fare */}
            <div className="item_bx text-end">
              <input
                className="form-check-input"
                type="radio"
                name={type}
                checked={checked}
                onChange={() =>
                  type === "onward"
                    ? setSelectedOnwardFlight(f)
                    : setSelectedReturnFlight(f)
                }
              />
              <div className="flight_charge">
                <i className="fa fa-inr"></i>{" "}
                {Number(
                  selectedFareMap[f?.itemNo]?.totalFare ??
                  f?.fares?.[0]?.totalFare ??
                  0
                ).toLocaleString("en-IN")}

                <p className="type_frs px-3">

                  {
                    selectedFareMap[f?.itemNo]?.journeyFareInfos?.[0]?.type ??
                    f?.fares?.[0]?.journeyFareInfos?.[0]?.type ??
                    "Regular"
                  }

                </p>
                <p
                  className={`policyStatus domIn ${f?.policyStatus === "WithinPolicy"
                    ? "text-success"
                    : f?.policyStatus === "OutOfPolicy"
                      ? "text-danger"
                      : ""
                    }`}
                >
                  {f?.policyStatus && (
                    <img
                      src={
                        f.policyStatus === "WithinPolicy"
                          ? "/assets/images/approved.png"
                          : f.policyStatus === "OutOfPolicy"
                            ? "/assets/images/cancelled.png"
                            : ""
                      }
                      alt="status"
                      style={{ marginRight: "6px" }}
                    />
                  )}

                  {f.policyStatus}
                </p>
                <div className="click_detls_it"
                  onClick={() => handleViewMoreFare(f)}
                >

                  View More Fare
                </div>
              </div>
            </div>
          </div>

          {/* DETAILS CLICK */}
          <div className="mainFlightVar">
            <div className="flightChild">
              <div className="d-flex">
                <div className="equipmentType">
                  <i className="fa-solid fa-fan"></i>
                  <span>{f.segments[0].equipmentType}</span>
                </div>

                <div className="equipmentType">
                  <img
                    className="seats"
                    src="/assets/images/seat.png"
                    alt="seat"
                  />
                  <span>{f.segments[0].availableSeats} Seats</span>
                </div>
              </div>
            </div>

            <div className="flightChild">
              <p
                className="refun"
                style={{
                  color: data.isRefundable ? "green" : "red",
                  fontWeight: "500",
                }}
              >
                {data.isRefundable ? "Refundable" : "Non Refundable"}
              </p>
            </div>
            <div className="flightChild">
              {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                <span style={{ color: 'green', }}>
                  {f.supSource}
                </span>
              )}
            </div>
            <div className="flightChild">
              <div className="click_detls_i"
                data-bs-toggle="offcanvas"
                data-bs-target="#FlightDetails1"
                onClick={() => {
                  const firstSeg = f?.segments?.[0];
                  const lastSeg = f?.segments?.[f?.segments?.length - 1];
                  setSelectedFlight({
                    ...f,
                    origin: firstSeg?.departCityName,
                    destination: lastSeg?.arrivalCityName,
                  });
                }}
              >
                <i class="fa fa-plane"></i> Flight Details

              </div>
            </div>

            <div className="flightChild">
              {(type === "onward" ? showAdSelctOnwrd : showAdSelctRound) && (
                <div className="form-check RandReturn">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={
                      type === "onward"
                        ? selectedOnwardFlights.includes(getFlightKey(f))
                        : selectedReturnFlights.includes(getFlightKey(f))
                    }
                    onChange={(e) =>
                      handleShareFlightChange(f, type, e.target.checked)
                    }
                    aria-label={`Select ${type} flight`}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      );
    });
  };



  const onwardFare = Number(
    selectedFareMap[selectedOnwardFlight?.itemNo]?.totalFare ||
    selectedOnwardFlight?.fares?.[0]?.totalFare ||
    0
  );

  const returnFare = Number(
    selectedFareMap[selectedReturnFlight?.itemNo]?.totalFare ||
    selectedReturnFlight?.fares?.[0]?.totalFare ||
    0
  );



  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };


  return (
    <>
      <div className="row">
        {/* Onward */}
        <div className="col-md-6 col-6 mb-300">
          <div className="from_to_plc">

            <h3 className="destnation">
              {data.departureAirportCode}{" "}
              <i className="fa fa-arrow-right"></i>{" "}
              {data.arrivalAirportCode}  || {" "}

              {[
                Number(data.adult) > 0 && `${data.adult} Adult`,
                Number(data.child) > 0 && `${data.child} Child`,
                Number(data.infant) > 0 && `${data.infant} Infant`,
              ]
                .filter(Boolean)
                .join(", ")}

              <span style={{ color: "red" }}>
                {" "}|| {formatDateForDisplay(data.onwardDate)}
              </span>
              || {requestBody.segments[0].preferredClass} ||

              {(sortedReturnFlights?.length || 0) > 0 && (
                <span style={{ color: "#ff0000", marginLeft: "4px" }}>
                  Flights: {sortedReturnFlights.length}
                </span>
              )}
              <span className="share_it_rt"
                onClick={() => setshowAdSelctOnwrd((prev) => !prev)}
                role="button" tabIndex={0}><img src="/assets/images/share.png" alt="share flights" /></span>
              {showAdSelctOnwrd && (
                <span className="shareit_rt" data-bs-toggle="modal" data-bs-target="#shareFlightsDomRetern"> :
                  <img src="/assets/images/copy.png" alt="share flights Details" />
                </span>
              )}
            </h3>



            <div className="d-flex-reco mb-3">
              <div
                className={`fastest ${onwardSortType === "CHEAPEST" ? "active" : ""}`}
                onClick={() => setOnwardSortType("CHEAPEST")}
              >
                <img src="/assets/images/rupee.png" alt="Cheapest" />
                <h4>Cheapest</h4>
              </div>

              <div
                className={`fastest ${onwardSortType === "FASTEST" ? "active" : ""}`}
                onClick={() => setOnwardSortType("FASTEST")}
              >
                <img src="/assets/images/speed.png" alt="Fastest" />
                <h4>Fastest</h4>
              </div>

              <div
                className={`fastest ${onwardSortType === "NONSTOP" ? "active" : ""}`}
                onClick={() => setOnwardSortType("NONSTOP")}
              >
                <img src="/assets/images/flight-blue.png" alt="Non Stop First" />
                <h4>Non Stop </h4>
              </div>

              <div
                className={`fastest ${onwardSortType === "DEPARTURE" ? "active" : ""}`}
                onClick={() => setOnwardSortType("DEPARTURE")}
              >
                <img src="/assets/images/flight-blue.png" alt="Departure" />
                <h4>Departure</h4>
              </div>
            </div>
          </div>
          <div className="scroll">
            {loading ? (
              <p className="text-center load">
                <span className="loader"></span>
              </p>
            ) : (
              renderFlights(sortedOnwardFlights, "onward")
            )}
          </div>
        </div>

        {/* Return */}
        <div className="col-md-6 col-6 mb-300">
          <div className="to_to_from_plc">

            <h3 className="destnation">
              {data.arrivalAirportCode}{" "}
              <i className="fa fa-arrow-right"></i>{" "}
              {data.departureAirportCode}  || {" "}
              {[
                Number(data.adult) > 0 && `${data.adult} Adult`,
                Number(data.child) > 0 && `${data.child} Child`,
                Number(data.infant) > 0 && `${data.infant} Infant`,
              ]
                .filter(Boolean)
                .join(", ")}

              <span style={{ color: "red" }}>
                {" "}|| {formatDateForDisplay(data.returnDate)}
              </span>
              || {requestBody.segments[0].preferredClass} ||

              {(sortedReturnFlights?.length || 0) > 0 && (
                <span style={{ color: "#ff0000", marginLeft: "4px" }}>
                  Flights: {sortedReturnFlights.length}
                </span>
              )}
              <span className="share_it_rt"
                onClick={() => setshowAdSelctRound((prev) => !prev)}
                role="button" tabIndex={0}><img src="/assets/images/share.png" alt="share flights" /></span>
              {showAdSelctRound && (
                <span className="shareit_rt" data-bs-toggle="modal" data-bs-target="#shareFlightsDomRetern"> :
                  <img src="/assets/images/copy.png" alt="share flights Details" />
                </span>
              )}
            </h3>

            <div className="d-flex-reco mb-3">
              <div
                className={`fastest ${returnSortType === "CHEAPEST" ? "active" : ""}`}
                onClick={() => setReturnSortType("CHEAPEST")}
              >
                <img src="/assets/images/rupee.png" alt="Cheapest" />
                <h4>Cheapest</h4>
              </div>

              <div
                className={`fastest ${returnSortType === "FASTEST" ? "active" : ""}`}
                onClick={() => setReturnSortType("FASTEST")}
              >
                <img src="/assets/images/speed.png" alt="Fastest" />
                <h4>Fastest</h4>
              </div>

              <div
                className={`fastest ${returnSortType === "NONSTOP" ? "active" : ""}`}
                onClick={() => setReturnSortType("NONSTOP")}
              >
                <img src="/assets/images/flight-blue.png" alt="Non Stop First" />
                <h4>Non Stop</h4>
              </div>

              <div
                className={`fastest ${returnSortType === "DEPARTURE" ? "active" : ""}`}
                onClick={() => setReturnSortType("DEPARTURE")}
              >
                <img src="/assets/images/flight-blue.png" alt="Departure" />
                <h4>Departure</h4>
              </div>
            </div>


          </div>
          <div className="scroll">
            {loading ? (
              <p className="text-center load">
                <span className="loader"></span>
              </p>
            ) : (
              renderFlights(sortedReturnFlights, "return")
            )}
          </div>
        </div>
      </div>

      {/* TOTAL */}
      <div className="total_amount Dom">

        {/* ONWARD FLIGHT */}
        {selectedOnwardFlight && (() => {

          const segments = selectedOnwardFlight.segments || [];
          const firstSeg = segments[0] || {};
          const lastSeg = segments[segments.length - 1] || {};
          const stops = segments.length > 0 ? segments.length - 1 : 0;

          return (
            <div className="onWords selected-flight">
              <div className="prodct_lst_round">

                <div className="item_bx">
                  <div className="flight_img_round">
                    <img
                      className="flight_i"
                      src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                      alt={firstSeg?.airLineName || ""}
                    />
                  </div>

                  <div className="flight_se">
                    <span>{firstSeg?.airLineName}</span>
                    <span>
                      {segments?.map((seg, i) => (
                        <span key={i}>
                          {seg.airLineCode}-{seg.flightNumber}
                          {i < segments.length - 1 && "/"}
                        </span>
                      ))}
                    </span>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="timer">
                    <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                    <p>{firstSeg?.departCityName}</p>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="deruation">
                    <p>{selectedOnwardFlight?.totalDuration}</p>
                    <div className="bordr_top">
                      <i className="fa fa-plane"></i>
                    </div>
                    <p className="stops">
                      {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                    </p>
                  </div>
                </div>

                <div className="item_bx text-center">
                  <div className="timer">
                    <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                    <p>{lastSeg?.arrivalCityName}</p>
                  </div>
                </div>

              </div>
            </div>
          );
        })()}


        {/* RETURN FLIGHT */}
        {selectedReturnFlight && (() => {

          const segments = selectedReturnFlight.segments || [];
          const firstSeg = segments[0] || {};
          const lastSeg = segments[segments.length - 1] || {};
          const stops = segments.length > 0 ? segments.length - 1 : 0;

          return (
            <div className="retrnWords">
              <div className="prodct_lst_round">

                <div className="item_bx">
                  <div className="flight_img_round">
                    <img
                      className="flight_i"
                      src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                      alt={firstSeg?.airLineName || ""}
                    />
                  </div>

                  <div className="flight_se">
                    <span>{firstSeg?.airLineName}</span>
                    <span>
                      {segments?.map((seg, i) => (
                        <span key={i}>
                          {seg.airLineCode}-{seg.flightNumber}
                          {i < segments.length - 1 && "/"}
                        </span>
                      ))}
                    </span>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="timer">
                    <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                    <p>{firstSeg?.departCityName}</p>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="deruation">
                    <p>{selectedReturnFlight?.totalDurationReturn}</p>
                    <div className="bordr_top">
                      <i className="fa fa-plane"></i>
                    </div>
                    <p className="stops">
                      {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                    </p>
                  </div>
                </div>

                <div className="item_bx text-center">
                  <div className="timer">
                    <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                    <p>{lastSeg?.arrivalCityName}</p>
                  </div>
                </div>

              </div>
            </div>
          );
        })()}


        {/* GRAND TOTAL */}
        <div className="retrnWord">
          <p className="Grand">Grand Total</p>
          <h1>
            <i className="fa fa-inr"></i>{" "}
            {(onwardFare + returnFare).toLocaleString("en-IN")}
          </h1>
        </div>

        {/* BUTTONS */}
        <div className="retrnWord mt-3">
          <button
            className="btn btn-primary mx-3"
            disabled={!selectedOnwardFlight || !selectedReturnFlight}
            onClick={() => {

              const onwardFareData =
                selectedFareMap[selectedOnwardFlight?.itemNo] ||
                selectedOnwardFlight?.fares?.[0];

              const returnFareData =
                selectedFareMap[selectedReturnFlight?.itemNo] ||
                selectedReturnFlight?.fares?.[0];

              const updatedOnward = {
                ...selectedOnwardFlight,
                selectedFare: onwardFareData,
                selectedFareIndex: onwardFareData?.selectedIndex ?? 0
              };

              const updatedReturn = {
                ...selectedReturnFlight,
                selectedFare: returnFareData,
                selectedFareIndex: returnFareData?.selectedIndex ?? 0
              };

              

              handleBookNow({
                onward: updatedOnward,
                return: updatedReturn
              });
            }}
          >
            Book Now
          </button>

          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#ModifyResult"
          >
            Modify Result
          </button>
        </div>

      </div>

      {/* OFFCANVAS Flight Details*/}
      <div className="offcanvas offcanvas-end" id="FlightDetails1">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setActiveTab("info");
              setLoadFareRule(false);
            }}
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>

              <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">

                {/* Flight Info */}

                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "info" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_4"
                    onClick={() => setActiveTab("info")}
                  >
                    Flight Information
                  </a>
                </li>

                {/* Fare Rules */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "fare" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_5"
                    onClick={() => {
                      setActiveTab("fare");

                      if (!selectedFlight?.itemNo) return;
                      setLoadFareRule(true);
                    }}
                  >
                    Fare Rules & Cancellation Change Rule
                  </a>
                </li>

                {/* Baggage */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "baggage" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_6"
                    onClick={() => setActiveTab("baggage")}
                  >
                    Baggage Information
                  </a>
                </li>



              </ul>

              <div className="tab-content" id="myTabContent">
                {/* ---------- TAB 1 : FLIGHT INFO ---------- */}
                {/* <div
                  className="tab-pane fade show active"
                  id="kt_tab_pane_4"
                  role="tabpanel"
                >
                  <div className="seLct_tab_flight">
                    <h3 className="destnation">
                      {selectedFlight.origin}
                      <i className="fa fa-arrow-right"></i>
                      {selectedFlight.destination}
                    </h3>

                    <ul className="rlst_flight_detls">
                      <li>
                        {selectedFlight?.tripType === 1
                          ? "One Way"
                          : "Round Trip"}
                      </li>
                      <li>{selectedFlight?.selClass || "Economy"}</li>
                      <li>
                        {(selectedFlight?.adult || 0) +
                          (selectedFlight?.child || 0) +
                          (selectedFlight?.infant || 0)}{" "}
                        Traveller(s)
                      </li>
                      <li>
                        {new Date(
                          selectedFlight?.segments?.[0]?.departDateTime
                        ).toDateString()}
                      </li>
                    </ul>

                    <div className="d-flex flgt_dlts">
                      <div className="img_img_flight">
                        <img
                          className="flight_i"
                          src={`/assets/images/Flight_Images/${selectedFlight?.segments?.[0]?.airLineCode}.gif`}
                          alt={selectedFlight?.segments?.[0]?.airLineName}
                        />
                      </div>

                      <div className="text_img_t">
                        <h5>
                          {new Date(
                            selectedFlight?.segments?.[0]?.departDateTime
                          ).toDateString()}
                        </h5>
                        <p>
                          {selectedFlight.origin} -{" "}
                          {selectedFlight.destination}

                        </p>
                      </div>
                    </div>

                    <div class="d-flex-v">
                      <div class="d-flex-v-f">
                        <h4>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</h4>
                      </div>
                      <div class="d-flex-v-m"><span class="zero"></span></div>
                      <div class="d-flex-v-l">
                        <h4>{selectedFlight.origin}</h4>
                        <p>  {selectedFlight.segments?.[0]?.departAirportName}
                          {selectedFlight.segments?.[0]?.departTerminal
                            ? `, Terminal ${selectedFlight.segments?.[0]?.departTerminal}`
                            : ""}</p>
                      </div>
                    </div>

                    <div className="d-flex-v time_to_frm">
                      <div className="d-flex-v-l m-autto">
                        {selectedFlight.segments?.map((seg, index) => {
                          const departDate = new Date(seg.departDateTime);
                          const arrivalDate = new Date(seg.arrivalDateTime);
                          const getDurationBetween = (fromTime, toTime) => {
                            const start = new Date(fromTime);
                            const end = new Date(toTime);

                            const diffMs = end - start;
                            if (diffMs <= 0) return "";

                            const minutes = Math.floor(diffMs / 60000);
                            const hrs = Math.floor(minutes / 60);
                            const mins = minutes % 60;

                            return `${hrs > 0 ? hrs + "h " : ""}${mins}m`;
                          };
                          const departTime = departDate.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          });

                          const arrivalTime = arrivalDate.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          });

                          const isLast = index === selectedFlight.segments.length - 1;
                          const nextSeg = selectedFlight.segments[index + 1];

                          const layoverDuration =
                            nextSeg &&
                            getDurationBetween(seg.arrivalDateTime, nextSeg.departDateTime);

                          return (
                            <div key={index}>
                              <div className="d-flex mb-3 align-items-center">
                                <div className="d-flex-v-f m-autto me-3">
                                  <h6>{departDate.toDateString()}</h6>
                                  <p className="mb-0">
                                    {departTime} ➜ {arrivalTime}
                                  </p>
                                </div>

                                <div className="d-flex-v-m fhty_rg">
                                  <i className="fa fa-plane flights"></i>
                                </div>

                                <div className="d-flex">
                                  <div className="img_flt">
                                    <img
                                      className="flight_i"
                                      src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                      alt={seg.airLineName}
                                    />
                                  </div>

                                  <div className="flt_name ms-2">
                                    {seg.airLineName} – {seg.airLineCode}-{seg.flightNumber}
                                  </div>
                                </div>
                              </div>

                              {!isLast && (
                                <div className="layover-info">
                                  <p className="mb-0">
                                    <strong>Stop:</strong>{" "}
                                    {seg.arrivalCity ||
                                      seg.arrivalAirportName ||
                                      seg.destination}
                                  </p>
                                  <h4 className="text-red">
                                    Layover : {layoverDuration}
                                  </h4>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="d-flex-v">
                      {(() => {
                        const segments = selectedFlight.segments || [];
                        const lastSeg = segments[segments.length - 1] || {};

                        return (
                          <>
                            <div className="d-flex-v-f">
                              <h4>{formatTime(lastSeg.arrivalDateTime)}</h4>
                            </div>

                            <div className="d-flex-v-m">
                              <span className="zero"></span>
                            </div>

                            <div className="d-flex-v-l">
                              <h4>{selectedFlight.destination || lastSeg.destination}</h4>
                              <p>
                                {lastSeg.arrivalAirportName}
                                {lastSeg.arrivalTerminal
                                  ? `, Terminal ${lastSeg.arrivalTerminal}`
                                  : ""}
                              </p>
                            </div>
                          </>
                        );
                      })()}
                    </div>



                  </div>
                </div> */}

                <div
                  className={`tab-pane fade ${activeTab === "info" ? "show active" : ""}`}
                  id="kt_tab_pane_4"
                >
                  {(() => {
                    const segments = selectedFlight?.segments || [];
                    const firstSeg = segments[0] || {};
                    const lastSeg = segments[segments.length - 1] || {};

                    const fmtDur = (d) => {
                      if (!d) return "N/A";
                      const [h, m] = String(d).split(":").map((n) => parseInt(n, 10) || 0);
                      return `${h > 0 ? `${h}h ` : ""}${m > 0 ? `${m}m` : ""}`.trim() || "N/A";
                    };

                    const diffDur = (from, to) => {
                      if (!from || !to) return "";
                      const diff = new Date(to) - new Date(from);
                      if (!(diff > 0)) return "";
                      const mins = Math.floor(diff / 60000);
                      return fmtDur(`${Math.floor(mins / 60)}:${mins % 60}`);
                    };

                    const fmtDate = (dt) =>
                      dt
                        ? new Date(dt).toLocaleDateString("en-GB", {
                          weekday: "short",
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        : "N/A";

                    const fmtTime = (dt) => (dt ? formatTime(dt) : "N/A");

                    const sameDay = (a, b) =>
                      new Date(a).toDateString() === new Date(b).toDateString();

                    const stopCount = Math.max(segments.length - 1, 0);
                    const travellers =
                      (Number(selectedFlight?.adult) || 0) +
                      (Number(selectedFlight?.child) || 0) +
                      (Number(selectedFlight?.infant) || 0);
                    const cabin = requestBody?.segments?.[0]?.preferredClass;
                    const destCity =
                      lastSeg.arrivalCityName || selectedFlight?.arrivalCityName || lastSeg.arrivalAirportCode;

                    return (
                      <div className="fd-wrap">
                        {/* ===== HEADER ===== */}
                        <div className="fd-hero">
                          <div className="fd-hero-route">
                            <div className="fd-hero-city">
                              <span className="fd-code">{firstSeg.departAirportCode}</span>
                              <span className="fd-city">{firstSeg.departCityName}</span>
                            </div>

                            <div className="fd-hero-mid">
                              <span className="fd-hero-dur">{fmtDur(selectedFlight?.totalDuration)}</span>
                              <div className="fd-hero-line">
                                <i className="fa fa-plane"></i>
                              </div>
                              <span className="fd-hero-stops">
                                {stopCount === 0 ? "Non-stop" : `${stopCount} Stop${stopCount > 1 ? "s" : ""}`}
                              </span>
                            </div>

                            <div className="fd-hero-city text-end">
                              <span className="fd-code">{lastSeg.arrivalAirportCode}</span>
                              <span className="fd-city">{destCity}</span>
                            </div>
                          </div>

                          <div className="fd-chips">
                            <span className="fd-chip"><i className="fa fa-calendar"></i> {fmtDate(firstSeg.departDateTime)}</span>
                            {cabin && <span className="fd-chip"><i className="fa fa-couch"></i> {cabin}</span>}
                            <span className="fd-chip"><i className="fa fa-user"></i> {travellers} Traveller(s)</span>
                          </div>
                        </div>

                        {/* ===== SEGMENTS ===== */}
                        {segments.map((seg, index) => {
                          const nextSeg = segments[index + 1];
                          const layover =
                            (seg.connectionTime && fmtDur(seg.connectionTime)) ||
                            (nextSeg && diffDur(seg.arrivalDateTime, nextSeg.departDateTime));
                          const overnight = !sameDay(seg.departDateTime, seg.arrivalDateTime);

                          return (
                            <React.Fragment key={`${seg.flightNumber || "f"}-${index}`}>
                              <div className="fd-card">
                                {/* Airline row */}
                                <div className="fd-airline">
                                  <div className="fd-airline-left">
                                    <img
                                      className="fd-logo"
                                      src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                      alt={seg.airLineName || "Airline"}
                                    />
                                    <div>
                                      <strong>{seg.airLineName || "Airline"}</strong>
                                      <small>
                                        {seg.airLineCode}-{seg.flightNumber}
                                        {seg.equipmentType ? ` • ${seg.equipmentType}` : ""}
                                      </small>
                                    </div>
                                  </div>
                                  {/* {stopCount > 0 && <span className="fd-badge">Flight {index + 1}</span>} */}
                                </div>

                                {/* Timeline */}
                                <div className="fd-timeline">
                                  {/* Departure */}
                                  <div className="fd-point">
                                    <div className="fd-time">
                                      <strong>{fmtTime(seg.departDateTime)}</strong>
                                      <small>{fmtDate(seg.departDateTime)}</small>
                                    </div>
                                    <span className="fd-dot"></span>
                                    <div className="fd-place">
                                      <h4>
                                        {seg.departCityName || seg.departAirportCode} ({seg.departAirportCode})
                                      </h4>
                                      <p>
                                        {seg.departAirportName}
                                        {seg.departTerminal && (
                                          <span className="fd-term">Terminal {seg.departTerminal}</span>
                                        )}
                                      </p>
                                    </div>
                                  </div>

                                  {/* Duration */}
                                  <div className="fd-travel">
                                    <i className="fa fa-clock"></i> {fmtDur(seg.duration)}
                                  </div>

                                  {/* Arrival */}
                                  <div className="fd-point">
                                    <div className="fd-time">
                                      <strong>{fmtTime(seg.arrivalDateTime)}</strong>
                                      <small>
                                        {fmtDate(seg.arrivalDateTime)}
                                        {overnight && <em className="fd-next">+1 day</em>}
                                      </small>
                                    </div>
                                    <span className="fd-dot fd-dot-end"></span>
                                    <div className="fd-place">
                                      <h4>
                                        {seg.arrivalCityName || seg.arrivalAirportCode} ({seg.arrivalAirportCode})
                                      </h4>
                                      <p>
                                        {seg.arrivalAirportName}
                                        {seg.arrivalTerminal && (
                                          <span className="fd-term">Terminal {seg.arrivalTerminal}</span>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Layover */}
                              {nextSeg && (
                                <div className="fd-layover">
                                  <i className="fa fa-hourglass-half"></i>
                                  <span>
                                    {/* Layover at{" "}
                    <strong>
                      {seg.arrivalCityName || seg.arrivalAirportName} ({seg.arrivalAirportCode})
                    </strong>
                    {" • "} */}
                                    <strong>{seg.layoverMessage || "N/A"}</strong>
                                    {/* {seg.changeOfPlane ? " • Change of plane" : ""} */}
                                  </span>
                                </div>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    );
                  })()}
                </div>

                <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div className="row">
                    <div className="col-md-12">
                      <FareRule
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={0}
                      />
                    </div>

                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Fare Type</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                       {/* {(selectedFlight.fares || []).map((fare, fareIndex) => ( */}
                        <tr>
                          <td>
                            <img
                              className="flight_name"
                              src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                              alt={selectedFlight.segments?.[0]?.airLineName}
                            />
                            <p className="plane_name">
                              {selectedFlight.segments?.[0]?.airLineName}
                            </p>
                                 <p className="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                          </td>

                          <td>{selectedFlight.fares?.[0]?.journeyFareInfos?.[0]?.type}</td>
                          <td>
                            {selectedFlight.fares?.[0]?.journeyFareInfos?.[0]?.baggageDetails?.[0]?.baggage}
                          </td>
                          <td>
                            {selectedFlight.fares?.[0]?.journeyFareInfos?.[0]?.baggageDetails?.[0]?.cabinBaggage}
                          </td>
                        </tr>
                      {/* ))} */}
                      
                      <tr>
                        <td colspan="4">
                          <div class="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>


      {/* View More Fare */}
      <div className="offcanvas offcanvas-end" id="ViewMoreFare" tabIndex="-1" aria-labelledby="ViewMoreFareLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title" id="ViewMoreFareLabel">
            More Fare Options Available
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight?.segments?.[0]?.airLineName || "airline"}
                    src={`/assets/images/Flight_Images/${selectedFlight?.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>

                <div className="flight_time">
                  {(() => {
                    const segments = selectedFlight?.segments || [];
                    const firstSeg = segments[0] || {};
                    const lastSeg = segments[segments.length - 1] || {};

                    return (
                      <>
                        <span>
                          <strong>
                            {firstSeg?.departCityName} ({firstSeg?.departAirportCode}) →{" "}
                            {lastSeg?.arrivalCityName} ({lastSeg?.arrivalAirportCode})
                          </strong>
                        </span>

                        <span>
                          <strong>{firstSeg?.airLineName}</strong>
                        </span>

                        <span>
                          <strong>
                            {firstSeg?.departDateTime
                              ? new Date(firstSeg.departDateTime).toDateString()
                              : ""}
                          </strong>
                        </span>

                        <span>
                          Departure at:{" "}
                          <strong>
                            {firstSeg?.departDateTime
                              ? formatTime(firstSeg.departDateTime)
                              : ""}
                          </strong>
                        </span>

                        <span>
                          Arrival at:{" "}
                          <strong>
                            {lastSeg?.arrivalDateTime
                              ? formatTime(lastSeg.arrivalDateTime)
                              : ""}
                          </strong>
                        </span>
                      </>
                    );
                  })()}
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares.map((fare, index) => {
                  const isSelected =
                    selectedFareMap[selectedFlight?.itemNo]?.selectedIndex === index;

                  return (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare?.journeyFareInfos?.[0]?.type}</h5>
                      <p
                        className={`policyStatus text-en ${fare?.policyStatus === "WithinPolicy"
                          ? "text-success"
                          : fare?.policyStatus === "OutOfPolicy"
                            ? "text-danger"
                            : ""
                          }`}
                      >
                        {fare?.policyStatus && (
                          <img
                            src={
                              fare.policyStatus === "WithinPolicy"
                                ? "/assets/images/approved.png"
                                : fare.policyStatus === "OutOfPolicy"
                                  ? "/assets/images/cancelled.png"
                                  : ""
                            }
                            alt="status"
                            style={{ marginRight: "6px" }}
                          />
                        )}

                        {fare.policyStatus}
                      </p>


                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {fare.totalFare?.toLocaleString("en-IN")}
                      </h3>
                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>

                        <p
                          className="faReRule"
                          data-bs-toggle="modal"
                          data-bs-target="#FareRuleModal"
                          onClick={() => {
                            if (!selectedFlight?.itemNo) return;
                            setLoadFareRule(true);
                            setFareRuleIndex(index);
                          }}
                        >
                          Fare Rule
                        </p>
                        <button
                          className="btn btn-sm"
                          style={{
                            backgroundColor: isSelected ? "#110942" : "",
                            color: isSelected ? "#fff" : ""
                          }}
                          // disabled={isSelected}
                          onClick={() => {
                            setSelectedFareMap(prev => ({
                              ...prev,
                              [selectedFlight.itemNo]: {
                                ...fare,
                                selectedIndex: index
                              }
                            }));
                          }}
                        >
                          {isSelected ? "Selected" : "Select"}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>


      </div>

      {/* Fare Rule For Perticular Fare */}

      <div className="modal fade" id="FareRuleModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Fare Rule</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={() => setLoadFareRule(false)}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                {selectedFlight && loadFareRule && fareRuleIndex !== null ? (
                  <>
                    <div className="col-md-12">
                      <FareRule
                        key={`${selectedFlight?.itemNo}_${loadFareRule}_${Date.now()}`}
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={fareRuleIndex}
                      />
                    </div>


                  </>
                ) : (
                  <p className="text-center">Loading fare rules...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* select flight to share start */}



      <div className="modal fade" id="shareFlightsDomRetern" tabIndex="-1">
        <div className="modal-dialog modal-90 modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Selected Flight to Share</h4>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="text_flght">
                <h6>Dear Sir/Ma'am,</h6>
                <p>
                  Please find the selected international round-trip flight
                  options below.
                </p>
              </div>

              {selectedOnwardFlightsToShare.length === 0 &&
                selectedReturnFlightsToShare.length === 0 ? (
                <p className="text-center text-muted mt-4">
                  Please select at least one flight option.
                </p>
              ) : (
                <>
                  {[
                    ...selectedOnwardFlightsToShare.map((flight) => ({
                      flight,
                      journey: "Onward",
                    })),
                    ...selectedReturnFlightsToShare.map((flight) => ({
                      flight,
                      journey: "Return",
                    })),
                  ].map(({ flight, journey }, optionIndex) => {
                    const segments = Array.isArray(flight?.segments)
                      ? flight.segments
                      : [];

                    const firstSeg = segments[0] || {};
                    const lastSeg = segments[segments.length - 1] || {};

                    // Get all fare options for this selected flight.
                    const fares = Array.isArray(flight?.fares)
                      ? flight.fares
                      : [];

                    return (
                      <div
                        className="row mb-4"
                        key={`${journey}-${getFlightKey(flight)}`}
                      >
                        <div className="col-md-12">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="optionIndex_list">
                              Option {optionIndex + 1} - {journey}
                            </h6>

                            <button
                              type="button"
                              className="btn btn-remove"
                              onClick={() => {
                                const flightKey = getFlightKey(flight);

                                if (journey === "Onward") {
                                  setSelectedOnwardFlights((prev) =>
                                    prev.filter((key) => key !== flightKey)
                                  );
                                } else {
                                  setSelectedReturnFlights((prev) =>
                                    prev.filter((key) => key !== flightKey)
                                  );
                                }
                              }}
                              aria-label={`Remove option ${optionIndex + 1}`}
                            >
                              <img
                                src="/assets/images/delete.png"
                                alt="Remove flight"
                                width={30}
                              />
                            </button>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="table table-bordered text-center align-middle mb-0">
                              <thead
                                style={{
                                  background: "#110942",
                                  color: "#fff",
                                }}
                              >
                                <tr>
                                  <th style={{ color: "#fff" }}>#</th>
                                  <th style={{ color: "#fff" }}>Journey</th>
                                  <th style={{ color: "#fff" }}>
                                    Airline / Flight
                                  </th>
                                  <th style={{ color: "#fff" }}>Departure</th>
                                  <th style={{ color: "#fff" }}>Arrival</th>
                                  <th style={{ color: "#fff" }}>Duration</th>
                                  <th style={{ color: "#fff" }}>Stops</th>
                                  <th style={{ color: "#fff" }}>Fare</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  <td>{optionIndex + 1}</td>
                                  <td>{journey}</td>

                                  {/* Airline and Flight Number */}
                                  <td>
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                      {firstSeg.airLineCode && (
                                        <img
                                          src={`/assets/images/Flight_Images/${firstSeg.airLineCode}.gif`}
                                          alt={firstSeg.airLineName || "Airline"}
                                          className="flight_i"
                                          style={{
                                            width: 30,
                                            height: "auto",
                                          }}
                                          onError={(e) => {
                                            e.currentTarget.style.display = "none";
                                          }}
                                        />
                                      )}

                                      <div>
                                        <div>
                                          {firstSeg.airLineName ||
                                            "Unknown Airline"}
                                        </div>

                                        <div>
                                          {segments
                                            .map(
                                              (segment) =>
                                                `${segment.airLineCode || ""}${segment.flightNumber
                                                  ? `-${segment.flightNumber}`
                                                  : ""
                                                }`
                                            )
                                            .join(" / ")}
                                        </div>
                                      </div>
                                    </div>
                                  </td>

                                  <td>
                                    {firstSeg.departCityName ||
                                      firstSeg.departAirportCode ||
                                      "N/A"}
                                    <br />
                                    {formatTime(firstSeg.departDateTime)}
                                  </td>

                                  <td>
                                    {lastSeg.arrivalCityName ||
                                      lastSeg.arrivalAirportCode ||
                                      "N/A"}
                                    <br />
                                    {formatTime(lastSeg.arrivalDateTime)}
                                  </td>

                                  <td>{flight.totalDuration || "N/A"}</td>

                                  <td>
                                    {segments.length <= 1
                                      ? "Non-stop"
                                      : `${segments.length - 1} Stop${segments.length > 2 ? "s" : ""
                                      }`}
                                  </td>

                                  {/* Display all fares */}
                                  <td>
                                    <table className="table table-bordered text-center align-middle mb-0">
                                      <thead>
                                        <tr>
                                          <th>
                                            Fare Type
                                          </th>
                                          <th>
                                            Amount (INR)
                                          </th>
                                          <th>
                                            Price Type
                                          </th>
                                          <th></th>
                                        </tr>
                                      </thead>


                                      <tbody>
                                        {fares.filter((_, fareIndex) => {
                                          const fareKey = `${journey}-${getFlightKey(flight)}-${fareIndex}`;
                                          return !removedShareFares.includes(fareKey);
                                        }).length === 0 ? (
                                          <tr>
                                            <td colSpan={4} className="text-center">
                                              No fares available
                                            </td>
                                          </tr>
                                        ) : (
                                          fares.map((fare, fareIndex) => {
                                            const fareKey =
                                              `${journey}-${getFlightKey(flight)}-${fareIndex}`;

                                            // Hide only the fare removed by clicking its cancel button.
                                            if (removedShareFares.includes(fareKey)) {
                                              return null;
                                            }

                                            const fareInfo = fare?.journeyFareInfos?.[0] || {};

                                            const fareType =
                                              fareInfo.fareName ||
                                              fareInfo.fareType ||
                                              fareInfo.type ||
                                              fare.fareName ||
                                              fare.fareType ||
                                              fare.type ||
                                              `Fare ${fareIndex + 1}`;

                                            const amount =
                                              fare.totalFare ??
                                              fare.amount ??
                                              fareInfo.totalFare ??
                                              fare.fare ??
                                              0;

                                            const isRefundable =
                                              fareInfo.isRefundable ?? fare.isRefundable;

                                            const priceType =
                                              fare.priceType ||
                                              fareInfo.priceType ||
                                              <span
                                                style={{
                                                  color:
                                                    isRefundable === true
                                                      ? "green"
                                                      : isRefundable === false
                                                        ? "red"
                                                        : "gray",
                                                  fontWeight: "500",
                                                }}
                                              >
                                                {isRefundable === true
                                                  ? "Refundable"
                                                  : isRefundable === false
                                                    ? "Non Refundable"
                                                    : "N/A"}
                                              </span>


                                            return (
                                              <tr key={fareKey}>
                                                <td>{fareType}</td>

                                                <td>
                                                  ₹{Number(amount).toLocaleString("en-IN")}
                                                </td>

                                                <td>{priceType}</td>

                                                <td className="text-center">
                                                  <button
                                                    type="button"
                                                    className="btn p-0 border-0 bg-transparent"
                                                    title="Remove fare"
                                                    aria-label={`Remove ${fareType}`}
                                                    onClick={() => {
                                                      setRemovedShareFares((previous) =>
                                                        previous.includes(fareKey)
                                                          ? previous
                                                          : [...previous, fareKey]
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src="/assets/images/cancelled.png"
                                                      alt=""
                                                      className="imgCancel"
                                                      style={{
                                                        width: 20,
                                                        height: 20,
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  </button>
                                                </td>
                                              </tr>
                                            );
                                          })
                                        )}
                                      </tbody>

                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>


            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleWhatsAppSelectedFlightsDomR}
                disabled={
                  selectedOnwardFlightsToShare.length === 0 &&
                  selectedReturnFlightsToShare.length === 0
                }
              >
                <img
                  src="/assets/images/whatsapp.png"
                  alt=""
                  width={20}
                />{" "}
                WhatsApp
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCopySelectedFlightsDomR}
                disabled={
                  selectedOnwardFlightsToShare.length === 0 &&
                  selectedReturnFlightsToShare.length === 0
                }
              >
                <img
                  src="/assets/images/copy-b.png"
                  alt=""
                  width={20}
                />{" "}
                Copy
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={handleDownloadSelectedFlightsDomR}
                disabled={
                  selectedOnwardFlightsToShare.length === 0 &&
                  selectedReturnFlightsToShare.length === 0
                }
              >
                <img
                  src="/assets/images/download-w.png"
                  alt=""
                  width={20}
                />{" "}
                Download Excel
              </button>
            </div>

          </div>
        </div>
      </div>


      {/* select flight to share End */}
    </>
  );
};

export default DomRoundTrip;
